import { FormControl, makeStyles, TextField, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import React, { useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
	select: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor:
				theme.palette.type === "dark"
					? "rgba(255, 255, 255, 0.24)"
					: "#e5e7eb"
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor:
				theme.palette.type === "dark"
					? "rgba(255, 255, 255, 0.38)"
					: "#d1d5db"
		},
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: theme.palette.type === "dark" ? "#4db6ac" : "#2563eb"
		}
	},
	label: {
		marginBottom: 6,
		color: theme.palette.text.secondary
	}
}));

export const LanguageDefault = ({ contact }) => {
	const classes = useStyles();
	const theme = useTheme();

	const languages = ["pt-BR", "en-US", "es-ES"];

	const [selectedLanguage, setSelectedLanguage] = useState(
		contact?.language || ""
	);

	const handleChange = async (value) => {
		setSelectedLanguage(value);

		try {
			await api.put("/update-language", {
				contactId: contact.id,
				language: value
			});
		} catch (error) {
			toastError(error);
		}
	};

	const inputBg =
		theme.palette.type === "dark"
			? "rgba(255, 255, 255, 0.06)"
			: "#fafafa";

	return (
		<FormControl fullWidth style={{ padding: "15px 10px" }}>
			<Typography variant="subtitle2" className={classes.label}>
				Language default
			</Typography>

			<Autocomplete
				freeSolo
				options={languages}
				value={selectedLanguage}
				onBlur={() => handleChange(selectedLanguage)}
				onInputChange={(e, value) => {
					setSelectedLanguage(value);
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						variant="outlined"
						placeholder="Select or type language"
						className={classes.select}
						InputProps={{
							...params.InputProps,
							style: {
								...params.InputProps.style,
								backgroundColor: inputBg,
								borderRadius: 12,
								height: 44
							}
						}}
					/>
				)}
			/>
		</FormControl>
	);
};
